import IndexedSearchCreate from './indexed-search-create';

export default IndexedSearchCreate;
